export default __webpack_public_path__ + "static/Lip_Top-Bottom-a4d42c7d7b36e1fe0ec80f45f4229eb7.jpg";